import { useMapAppContext } from '@/microfrontends/map/shared/context/mapAppContext';

export function useGetMapConstructorOptions(): YMaps.IMapOptions {
  const { config } = useMapAppContext();

  return config.get<YMaps.IMapOptions>('search-frontend.yandexMaps.constructorOptions') || {};
}
